import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import BasicLangChip from '../../core/BasicLangChip';
import withGS from '../../core/withGShoc';
import GS from '../../grafsync/grafsync';
import { CONCEPT_LOAD_OPTIONS, STATUS_REJECTED } from '../../core/utils/constants';
import { getNewTabLink } from '../../core/utils/utils';

const REJECTED = STATUS_REJECTED;

class ConceptLink extends React.Component {

    handleDeleteLink = () => {
        if (this.props.onDeleteIRI) {
            this.props.onDeleteIRI(this.props.id);
        }
        else {
            // We do this directly to ensure direction of link delete is correct 
            GS.deleteProperty(this.props.source, this.props.graph, this.props.property, this.props.target, null, null, this.props.propertyGraph);
        }
    };

    // We allow a click function or a link
    handleClick = (event) => {
        if (this.props.onClick) {
            this.props.onClick();
        }
        else {
            if (this.props.link && event.ctrlKey) {
                getNewTabLink(this.props.link);
                return;
            }
            this.props.history.push(this.props.link);
            if (this.props.onLink) this.props.onLink();
        }
    };

    render() {

        const { data, defaultLang, viewLang, isReadOnly, otherScheme, disabled,
            highlight, compact, avatar, useWorkflow } = this.props;

        const isRejected = useWorkflow && !otherScheme && "status" in data && data.status[0] === REJECTED ? true : false;

        const currentId = data.iri && data.iri.length > 0 ?
            data.iri[data.iri.length - 1]
            :
            data.id;

        return (
            <BasicLangChip
                highlight={highlight}
                additionalAvatar={avatar}
                id={currentId}
                compact={compact}
                disabled={disabled}
                deprecated={data.deprecated === true}
                deleted={data.pendingDeletion === true || isRejected}
                viewLang={viewLang}
                additionalIcon={otherScheme}
                defaultLang={defaultLang}
                label={data.prefLabel}
                onClick={this.handleClick}
                onDelete={!isReadOnly ? this.handleDeleteLink : null} />
        );
    }
}

ConceptLink.defaultProps = {
    highlight: false,
    disabled: false,
    compact: false
};

ConceptLink.propTypes = {
    classes: PropTypes.object,
    highlight: PropTypes.bool,
    data: PropTypes.object.isRequired,
    avatar: PropTypes.object,
    id: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    source: PropTypes.string,
    target: PropTypes.string,
    isReadOnly: PropTypes.bool,
    compact: PropTypes.bool,
    otherScheme: PropTypes.bool,
    useWorkflow: PropTypes.bool,
    onDeleteIRI: PropTypes.func,
    onClick: PropTypes.func,
    onLink: PropTypes.func,
    graph: PropTypes.string.isRequired,
    propertyGraph: PropTypes.string,
    link: PropTypes.string,
    property: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    updateEvent: PropTypes.func
};

export default withRouter(withGS(ConceptLink, ["ALL"], null, CONCEPT_LOAD_OPTIONS, true));